import { Pipe, PipeTransform } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';

@Pipe({ name: 'isSelected' })
export class IsSelectedPipe implements PipeTransform {
  transform(item: SelectionModel<any>, value: any) {
    return item.isSelected(value);
  }
}
